import { render, staticRenderFns } from "./wxasearchstatus.vue?vue&type=template&id=edaa35b4&"
import script from "./wxasearchstatus.vue?vue&type=script&lang=ts&"
export * from "./wxasearchstatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports